// extracted by mini-css-extract-plugin
module.exports = {"vanlife-G":"G_vanlife-G__ddOfR"};